module.exports = {"airplay":["stream"],"bell":["alarm","notification"],"settings":["cog","edit","gear","preferences"],"star":["bookmark"],"x":["cancel","close","delete","remove"]}


//////////////////
// WEBPACK FOOTER
// ./src/tags.json
// module id = 89
// module chunks = 0